(function () {
    function trackLink(event) {
        if (event.type === 'auxclick' && event.button !== 1) return;
        var anchor = event.target.closest && event.target.closest('a[href]');
        if (!anchor || !window.umami || typeof window.umami.track !== 'function') return;

        var url;
        try {
            url = new URL(anchor.href, location.href);
        } catch (error) {
            return;
        }
        if (url.protocol !== 'https:' || url.hostname !== 'bitz.io') return;

        var path = url.pathname.replace(/\/+$/, '') || '/';
        var placement = anchor.closest('.bitz-news-hero') ? 'hero' :
            anchor.closest('.gh-head-menu') ? 'navigation' :
                anchor.closest('.gh-content') ? 'digest' : 'other';
        var name;
        if (path === '/') {
            name = 'casino-click';
        } else if (placement === 'digest') {
            name = path === '/blog' ? 'blog-index-click' : 'blog-click';
        } else {
            return;
        }

        // Delegate clicks so old posts and dynamically rendered links work too.
        // Analytics must never prevent the link's normal navigation.
        try {
            var result = window.umami.track(name, {url: url.origin + path, placement: placement});
            if (result && typeof result.catch === 'function') result.catch(function () {});
        } catch (error) {}
    }

    document.addEventListener('click', trackLink);
    document.addEventListener('auxclick', trackLink);
})();
